import React, { useEffect, useState, useRef } from "react";
import Header from "../component/Header";
import Footer from "../component/Footer";
import { Helmet } from "react-helmet";

const API_PDF_URL = process.env.REACT_APP_API_PDF_URL;
const BASE_URL = process.env.REACT_APP_BASE_URL;


const ConcallTranscripts = () => {
  const pageid = 16; // <-- replace with actual pageid for concall transcripts
  const [transcripts, setTranscripts] = useState([]);
  const [loading, setLoading] = useState(true);
  const yearRefs = useRef({});

  useEffect(() => {
    const fetchTranscripts = async () => {
      try {
        const response = await fetch(`${BASE_URL}?pageid=${pageid}`);
        if (!response.ok) throw new Error(`HTTP error! ${response.status}`);
        const result = await response.json();

        if (!result.success || !Array.isArray(result.data)) {
          setTranscripts([]);
          return;
        }

        // Group by year
        const grouped = {};
        result.data.forEach((item) => {
          const year = item.year_name;
          if (!grouped[year]) grouped[year] = [];
          grouped[year].push({
            label: item.pdf_name,
            file: item.upload_file_path,
          });
        });

        const finalData = Object.keys(grouped)
          .map((year) => ({ year, reports: grouped[year] }))
          .sort((a, b) => b.year - a.year);

        setTranscripts(finalData);
      } catch (error) {
        console.error("Fetch failed:", error);
        setTranscripts([]);
      } finally {
        setLoading(false);
      }
    };

    fetchTranscripts();
  }, []);

  // Scroll to first year
  useEffect(() => {
    if (transcripts.length > 0) {
      const el = yearRefs.current[transcripts[0].year];
      if (el) el.scrollIntoView({ behavior: "smooth" });
    }
  }, [transcripts]);

  return (
    <>
      <Helmet>
        <title>Concall Transcripts | Nandan Denim Ltd.</title>
      </Helmet>
      <Header />

      {/* Hero Section */}
      <div className="relative w-full mb-10">
        <img
          src="./imgs/investors/investorconcalltranscripts.png"
          alt="Chiripal Group Banner"
          className="object-cover w-full h-full md:h-[70vh] lg:h-[80vh] xl:h-[88vh]"
        />
        <div className="absolute inset-0 flex items-center">
          <div className="px-4 sm:px-8 md:px-16 lg:px-32">
            <h1 className="text-yellow-400 text-3xl sm:text-5xl md:text-7xl font-montserrat font-bold text-left">
              Concall Transcripts
            </h1>
          </div>
        </div>
      </div>

      {/* PDF Section */}
      <div className="py-12 px-4 font-signika max-w-7xl mx-auto">
        {loading ? (
          <p>Loading concall transcripts...</p>
        ) : transcripts.length === 0 ? (
          <p>No concall transcripts found.</p>
        ) : (
          transcripts.map((yearGroup, index) => (
            <div
              key={index}
              ref={(el) => (yearRefs.current[yearGroup.year] = el)}
              className="mb-10"
            >
              <h2 className="text-2xl font-extrabold text-[#0b3a6a] uppercase mb-4">
                For the Year {yearGroup.year}
              </h2>
              <ul className="list-disc pl-5 text-[#0b3a6a] font-medium space-y-2">
                {yearGroup.reports.map((report, idx) => (
                  <li key={idx}>
                    <a
                      href={report.file ? `${API_PDF_URL}/${report.file}` : "#"} // ✅ Use # if no PDF
                      target={report.file ? "_blank" : "_self"}
                      rel="noopener noreferrer"
                      className="hover:underline"
                    >
                      {report.label}
                    </a>
                  </li>
                ))}
              </ul>
              <hr className="mt-4 border-gray-300" />
            </div>
          ))
        )}
      </div>

      <Footer />
    </>
  );
};

export default ConcallTranscripts;
